import { render, staticRenderFns } from "./FlexIcon.vue?vue&type=template&id=c07e9c84&"
import script from "./FlexIcon.vue?vue&type=script&lang=js&"
export * from "./FlexIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports